<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Card Monitoring</h2>
          </div>
          <div class="body pt-0">
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              responsive
              ref="customerTable"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(usersofcard)="data">
                <a href="javascript:void(0);" v-b-modal.linkedSenders>
                  {{ data.value }}
                </a>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Cancel</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="linkedSenders"
              size="lg"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Linked Remitters
                </h5>
              </template>
              <div class="modal-area">
                <b-table
                  table-class="table-custom border"
                  head-variant="light"
                  :items="linkedSenders"
                  :fields="linkedSendersfields"
                  responsive
                  striped
                  hover
                >
                  <template #cell(country)="data">
                    <div class="align-items-center d-flex">
                      <span :class="data.value.flagClass"></span>
                      <span
                        class="ml-2"
                        v-b-tooltip.hover
                        :title="data.item.country.name"
                      >
                        {{ data.item.country.isocode.toUpperCase() }}
                      </span>
                    </div>
                  </template>
                  <template #cell(name)="data">
                    <a
                      href="javascript:void(0);"
                      class="font-color"
                      @click="customerDetailModel(data.item)"
                    >
                      {{ data.value }}
                      <i
                        class="fa fa-ban text-danger ml-1"
                        v-if="data.index == 2"
                      ></i>
                    </a>
                  </template>
                  <template #cell(payangel_id)="data">
                    <span>
                      {{ data.value }}
                      <i
                        class="fa fa-copy"
                        v-if="data.value != '-'"
                        @click="copyText(data.value, 'Payangel Id')"
                      ></i>
                    </span>
                  </template>
                  <template #cell(ipaddress)="data">
                    <span>
                      {{ data.value }}
                      <i
                        class="fa fa-copy"
                        v-if="data.value != '-'"
                        @click="copyText(data.value, 'IP address')"
                      ></i>
                    </span>
                  </template>
                  <template #cell(status)="data">
                    <p class="function-badge badge-group-table mb-0">
                      <span class="badge ml-0" :class="data.value.class">
                        {{ data.value.name }}
                      </span>
                    </p>
                  </template>
                </b-table>
              </div>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetailsModel :customerDetail="customerDetail" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapState, mapGetters } from "vuex";
import { GET_CUSTOMER_DETAILS } from "../../../store/actions.type.js";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "CardMonitoringComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
  },
  methods: {
    customerDetailModel(item) {
      this.$store.dispatch(GET_CUSTOMER_DETAILS, item.id).then((response) => {
        if (response.status == 200) {
          const customerdetails = response.data;
          this.$bvModal.show("customer-details");
          this.customerDetail = customerdetails;
        }
      });
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
  },
  data() {
    return {
      customerDetail: null,
      linkedSenders: [
        {
          name: "Robert Evans",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          payangel_id: "PA1524",
          ipaddress: "265.168.1.148/test",
          status: { name: "N /A", class: "badge-grey" },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
        {
          name: "Selena Parker",
          country: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          payangel_id: "PA1524",
          ipaddress: "192.168.1.148/test",
          status: { name: "Valid", class: "badge-success" },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
        {
          name: "Lusifer Boswell",
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          payangel_id: "PA1524",
          ipaddress: "308.168.1.148/test",
          status: { name: "Blocked", class: "badge-danger" },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
        {
          name: "Mark Richards",
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          payangel_id: "PA1524",
          ipaddress: "48.168.1.148/test",
          status: { name: "Expired", class: "badge-warning" },
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
      ],
      linkedSendersfields: [
        { key: "country", label: "Country", tdClass: "p-2" },
        { key: "name", label: "Name", tdClass: "p-2" },
        { key: "payangel_id", label: "Payangel ID", tdClass: "p-2" },
        { key: "ipaddress", label: "IP address", tdClass: "p-2" },
        { key: "status", label: "status", tdClass: "p-2" },
      ],
      items: [
        {
          card: "Master Card(Debit)",
          cardnumber: "2335-65**-****-2548",
          expirydate: "04/27",
          usersofcard: 5,
        },
        {
          card: "Rupay (Credit)",
          cardnumber: "2335-65**-****-7548",
          expirydate: "01/32",
          usersofcard: 1,
        },
        {
          card: "Visa (Credit)",
          cardnumber: "2335-65**-****-3596",
          expirydate: "08/28",
          usersofcard: 19,
        },
      ],

      fields: [
        {
          key: "card",
          label: "Card Name",
          thStyle: { width: "25%" },
          sortable: true,
        },
        {
          key: "cardnumber",
          label: "Card Number",
          thStyle: { width: "25%" },
          sortable: true,
        },
        {
          key: "expirydate",
          label: "Expiry Date",
          thStyle: { width: "25%" },
          sortable: true,
        },
        {
          key: "usersofcard",
          label: "# of Users of Card",
          sortable: true,
          thStyle: { width: "25%" },
          tdClass: "pl-5",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          thClass: "th_sortfix text-right pr-4",
          thStyle: { width: "15%" },
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      isVisibleFilter: false,

      search: {
        from: "",
        to: "",
        fname: "",
        mname: "",
        lname: "",
        rgroup: null,
        rstatus: null,
        keywords: "",
      },
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
